/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type Model from '@ember-data/model';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { taskFor } from 'ember-concurrency-ts';

export default class HandoffToSalesforceOwnerIdValid extends BaseValidator {
  @service declare intl: IntlService;

  async validate(
    _value: unknown,
    options: ValidationOptions & { messageKey: string },
    model: Model & {
      handoffToSalesforceOwnerId: string | undefined;
      finStandaloneService: FinStandaloneService;
    },
  ) {
    if (model.handoffToSalesforceOwnerId) {
      await this.waitForSalesforceSetupData(model.finStandaloneService);
      let { admins = [], queues = [] } = model.finStandaloneService.salesforceSetupData;
      let handOffOptions = [...admins.mapBy('id'), ...queues.mapBy('id')];
      if (handOffOptions.includes(model.handoffToSalesforceOwnerId)) {
        return true;
      }
    }

    return this.intl.t(options.messageKey);
  }

  static getDependentsFor() {
    return ['model.handoffToSalesforceOwnerId', 'model.finStandaloneService.salesforceSetupData'];
  }

  async waitForSalesforceSetupData(finStandaloneService: FinStandaloneService) {
    // This works under the assumption that the salesforce setup data is loaded or loading.
    // As part of initializing the finStandaloneService.
    if (!taskFor(finStandaloneService.salesforceDataLoader.loadSalesforceSetupData).isRunning) {
      return;
    }

    return taskFor(finStandaloneService.salesforceDataLoader.loadSalesforceSetupData).last!;
  }
}
